// extracted by mini-css-extract-plugin
export default {"itemCheckMark":"playback-rate-option-module__itemCheckMark___CAaHk","value":"playback-rate-option-module__value___AaYzy"};